import { render, staticRenderFns } from "./HorizontalEbook.vue?vue&type=template&id=2103f705&scoped=true"
import script from "./HorizontalEbook.vue?vue&type=script&lang=js"
export * from "./HorizontalEbook.vue?vue&type=script&lang=js"
import style0 from "./HorizontalEbook.vue?vue&type=style&index=0&id=2103f705&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103f705",
  null
  
)

export default component.exports